import { render } from "./infoOfInstitution.vue?vue&type=template&id=41778eac"
import script from "./infoOfInstitution.vue?vue&type=script&lang=js"
export * from "./infoOfInstitution.vue?vue&type=script&lang=js"

import "./infoOfInstitution.vue?vue&type=style&index=0&id=41778eac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__